import { getDefaultState as getDefaultUiState } from '@ducks/ui';

export function getDefaultState() {
  const ui = getDefaultUiState();
  return {
    ui,
  };
}
